export enum NewsLetterError {
	NEWS_ERROR = 'There was an error loading NewsLetter. Please try again.',
	DELETE_ERROR = 'Error deleting NewsLetter',
	EDIT_ERROR = 'Error editing NewsLetter',
	CREATE_ERROR = 'Error creating NewsLetter',
	NAME_ERROR = 'NewsLetter name is required',
	DESCRIPTION_ERROR = 'NewsLetter description is required',
}